/* ============================================================
   VIVĀRA — TESTIMONIALS (Ritual Reflections)
   ------------------------------------------------------------
   READ THIS BEFORE THE STORE TAKES ORDERS
   ---------------------------------------
   The three entries below are copy written to show the layout. Nobody said
   them. They are flagged `placeholder: true` and render only while
   PLACEHOLDER_MODE is true — set it to false and every one of them
   disappears, and the section removes itself if nothing genuine remains.
   Publishing invented reviews on a storefront that takes orders is
   deceptive under FTC rules, so replace these with real, consented
   customer quotes before launch.

   A real entry takes this shape:

     {
       quote:        "exact approved words, unedited",
       firstName:    "Anna",
       lastInitial:  "R",
       location:     "Los Angeles, CA",     // optional
       purchaseStatus: "verified",          // "verified" | "customer" | "unverified"
       date:         "2026-03-14",          // ISO, date given
       consent:      true,                  // written consent on file — required
       image:        null,                  // optional, customer-supplied
       imageAlt:     null,
       material:     null                   // REQUIRED disclosure of any free product,
                                            // discount, incentive, employment,
                                            // friendship or other relationship
     }

   Rules enforced below:
   · entries without written consent are never rendered
   · "Verified Purchase" only when purchaseStatus === "verified";
     otherwise "Early Customer", or no label at all
   · a material connection is always disclosed beside the quote
   · with no publishable entries the whole section is removed from the
     page rather than shown empty

   SHOPIFY MIGRATION
   -----------------
   → metaobject definition `testimonial` (or a reviews app feed).
   The render function maps 1:1 to snippets/testimonials.liquid.
   ============================================================ */
(function () {
  "use strict";

  /* ------------------------------------------------------------------
     PLACEHOLDER MODE
     ------------------------------------------------------------------
     The entries below are SAMPLE COPY written to show the layout. They are
     not customer statements and nobody said them.

     To go live: set PLACEHOLDER_MODE to false and add real entries. Anything
     still flagged `placeholder: true` disappears the moment the switch flips,
     and the section removes itself entirely if nothing genuine remains.
     The on-page "sample copy" notice was removed at the client's request;
     this flag is now the only thing standing between the copy below and a
     live storefront.
     ------------------------------------------------------------------ */
  var PLACEHOLDER_MODE = true;

  var DATA = [
    {
      quote: "It has become the first thing I do after water in the morning. The bottle sits where I can see it, and that alone is what keeps the habit.",
      firstName: "Anaïs", lastInitial: "R", location: "Brooklyn, NY",
      purchaseStatus: "verified", date: "2026-06-18",
      consent: false, placeholder: true, image: null, imageAlt: null, material: null
    },
    {
      quote: "I expected the taste to be the difficult part. It is earthy and mineral, and it disappears completely in coffee & smoothies.",
      firstName: "Marcus", lastInitial: "D", location: "Austin, TX",
      purchaseStatus: "verified", date: "2026-05-02",
      consent: false, placeholder: true, image: null, imageAlt: null, material: null
    },
    {
      quote: "The packaging is what made me try it. The ritual is what made me reorder — three months in and I still look forward to it.",
      firstName: "Priya", lastInitial: "N", location: "San Francisco, CA",
      purchaseStatus: "customer", date: "2026-04-21",
      consent: false, placeholder: true, image: null, imageAlt: null,
      material: "Received a complimentary bottle."
    }
  ];

  /* ------------------------------------------------------------------
     ILLUSTRATIVE PORTRAITS
     ------------------------------------------------------------------
     Commissioned brand imagery used when a reviewer has supplied no
     photograph of their own. They are not photographs of the people quoted.
     A customer-supplied `image` always wins.
     SHOPIFY: theme setting / metaobject `reflection_portrait`.
     ------------------------------------------------------------------ */
  var ILLUSTRATIVE = [
    (window.VIVARA_ASSET_ROOT || "assets/img/portraits/") + "reviewer-01.jpg",
    (window.VIVARA_ASSET_ROOT || "assets/img/portraits/") + "reviewer-02.jpg",
    (window.VIVARA_ASSET_ROOT || "assets/img/portraits/") + "reviewer-03.jpg",
    (window.VIVARA_ASSET_ROOT || "assets/img/portraits/") + "reviewer-04.jpg",
    (window.VIVARA_ASSET_ROOT || "assets/img/portraits/") + "reviewer-05.jpg"
  ];

  function assetUrl(path) {
    var root = window.VIVARA_ASSET_ROOT || "";
    return root + String(path).split("/").pop();
  }

  window.VIVARA_TESTIMONIALS = DATA;

  function publishable(t) {
    if (!t || typeof t.quote !== "string" || !t.quote.trim()) return false;
    /* Sample copy renders only while the switch is on. A real entry always
       needs written consent on file, with no exception. */
    if (t.placeholder === true) return PLACEHOLDER_MODE === true;
    return t.consent === true;
  }

  function labelFor(t) {
    if (t.purchaseStatus === "verified") return "Verified Purchase";
    if (t.purchaseStatus === "customer") return "Early Customer";
    return null;
  }

  function attribution(t) {
    var name = [t.firstName, t.lastInitial ? t.lastInitial + "." : null]
      .filter(Boolean).join(" ");
    return [name, t.location].filter(Boolean).join(" · ");
  }

  function card(t, i) {
    var fig = document.createElement("figure");
    fig.className = "refl-card refl-card--" + (i + 1) + (i === 0 ? " refl-card--featured" : "");
    fig.setAttribute("data-reveal", "");

    var own = !!t.image;
    var src = t.image || ILLUSTRATIVE[i % ILLUSTRATIVE.length];

    if (src) {
      var frame = document.createElement("span");
      frame.className = "refl-portrait";
      var img = document.createElement("img");
      img.src = own ? t.image : assetUrl(src);
      img.alt = own ? (t.imageAlt || "") : "";
      if (!own) img.setAttribute("aria-hidden", "true");
      img.loading = "lazy";
      img.decoding = "async";
      img.width = 900;
      img.height = 1200;
      frame.appendChild(img);
      fig.appendChild(frame);
      fig.setAttribute("data-portrait", own ? "customer" : "illustrative");
    } else {
      var mark = document.createElement("span");
      mark.className = "refl-mark";
      mark.setAttribute("aria-hidden", "true");
      mark.textContent = "”";
      fig.appendChild(mark);
    }

    var q = document.createElement("blockquote");
    q.className = "refl-quote";
    q.textContent = "“" + t.quote + "”";
    fig.appendChild(q);

    var cap = document.createElement("figcaption");
    cap.className = "refl-cap";

    var who = document.createElement("span");
    who.className = "refl-context";
    who.textContent = attribution(t);
    cap.appendChild(who);

    var label = labelFor(t);
    if (label) {
      var badge = document.createElement("span");
      badge.className = "refl-badge";
      badge.textContent = label;
      cap.appendChild(badge);
    }

    if (t.date) {
      var time = document.createElement("time");
      time.className = "refl-date";
      time.dateTime = t.date;
      time.textContent = new Date(t.date + "T00:00:00").toLocaleDateString("en-US", {
        year: "numeric", month: "long"
      });
      cap.appendChild(time);
    }


    /* Material connections must always be disclosed. */
    if (t.material) {
      var disc = document.createElement("span");
      disc.className = "refl-disclosure";
      disc.textContent = t.material;
      cap.appendChild(disc);
    }

    fig.appendChild(cap);
    return fig;
  }

  /* ------------------------------------------------------------------
     FEATURED REFLECTION
     One quote placed beside the purchase decision. Same data, same rules;
     if nothing is publishable the host section removes itself so the page
     closes up with no empty band.
     ------------------------------------------------------------------ */
  function featured(host) {
    var section = host.closest("section");
    var list = DATA.filter(publishable);
    if (!list.length) {
      if (section) section.remove(); else host.remove();
      return;
    }

    var t = list[0];
    var fig = document.createElement("figure");
    fig.className = "feat-refl-card";
    fig.setAttribute("data-reveal", "");

    var src = t.image || ILLUSTRATIVE[0];
    if (src) {
      var frame = document.createElement("span");
      frame.className = "feat-refl-portrait";
      var img = document.createElement("img");
      img.src = t.image ? t.image : assetUrl(src);
      img.alt = t.image ? (t.imageAlt || "") : "";
      if (!t.image) img.setAttribute("aria-hidden", "true");
      img.loading = "lazy";
      img.decoding = "async";
      img.width = 240;
      img.height = 320;
      frame.appendChild(img);
      fig.appendChild(frame);
    }

    var body = document.createElement("div");
    body.className = "feat-refl-body";

    var q = document.createElement("blockquote");
    q.className = "feat-refl-quote";
    q.textContent = "\u201C" + t.quote + "\u201D";
    body.appendChild(q);

    var cap = document.createElement("figcaption");
    cap.className = "feat-refl-cap";

    var who = document.createElement("span");
    who.className = "refl-context";
    who.textContent = attribution(t);
    cap.appendChild(who);

    var label = labelFor(t);
    if (label) {
      var badge = document.createElement("span");
      badge.className = "refl-badge";
      badge.textContent = label;
      cap.appendChild(badge);
    }


    if (t.material) {
      var disc = document.createElement("span");
      disc.className = "refl-disclosure";
      disc.textContent = t.material;
      cap.appendChild(disc);
    }

    body.appendChild(cap);
    fig.appendChild(body);

    host.innerHTML = "";
    host.appendChild(fig);
  }

  function init() {
    document.querySelectorAll("[data-testimonial-featured]").forEach(featured);

    document.querySelectorAll("[data-testimonials]").forEach(function (host) {
      var section = host.closest("section");
      var limit = parseInt(host.getAttribute("data-testimonials-limit") || "5", 10);
      var list = DATA.filter(publishable).slice(0, limit);

      /* Nothing genuine to show → remove the section entirely. */
      if (!list.length) {
        if (section) section.remove(); else host.remove();
        return;
      }

      host.innerHTML = "";
      host.setAttribute("data-reveal-group", "");
      list.forEach(function (t, i) { host.appendChild(card(t, i)); });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
